import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      errors: {
        selectAnyValue: 'Please make a selection.',
        medicationName: 'Medication name is required.',
        medicationRxcui: 'Medication RXCUI is required.',
        medicationForm: 'Medication form is required.',
        dosageRequired: 'Dosage is required.',
        frequencyRequired: 'Frequency is required.',
        recipientRequired: 'Recipient is required.',
        firstNameRequired: 'First name is required.',
        lastNameRequired: 'Last name is required.',
        midNameInvalid: 'Middle contains invalid characters',
        lastNameInvalid: 'Last name contains invalid characters',
        firstNameInvalid: 'First name contains invalid characters',
        genderRequired: 'Gender is required.',
        monthRequired: 'Month is required.',
        dayRequired: 'Day is required.',
        yearRequired: 'Year is required.',
        heightRequired: 'Height is required.',
        heightTooHigh: 'Height (ft) must be between 1 and 7',
        inchesTooHigh: 'Height (in) must be between 0 and 11',
        zeroHeight: 'Height cannot be 0 ft 0 in.',
        weightRequired: 'Weight is required.',
        weightTooLow: 'Weight must not be less than 7.',
        weightTooHigh: 'Weight must not be greater than 800.',
        incomeRequired: 'Income is required.',
        pleaseSelectAtLeastOne: 'Please select at least one option.',
        effectiveDateRequired: 'Please select effective date.',
        disclaimerRequired: 'Please confirm the disclaimer.',
        privacyDisclosureRequired: 'Please acknowledge the privacy disclosure.',
        signatureRequired: 'Please provide a signature.',
        yesNoRequired: 'Please select yes or no.',
        treatmentRequired: 'Please answer the treatment question.',
        invalidRequired: 'Please answer the invalid question.',
        pregnancyRequired: 'Please answer the pregnancy question.',
        specifyAnyMedication:  'Looks like you chose <strong>Yes</strong>. Add at least one medication, or switch to <strong>No</strong> if none apply.'
      },
    },
  },
};

void i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  });

export const t = i18n.t.bind(i18n);
export default i18n;
